import { Sparkles, ArrowUpRight, Zap } from "lucide-react";

const TONINI_URL =
  "https://www.myner-adria.com/tonini-bitlab";

/**
 * "Saznajte više o Tonini viziji" – animirani CTA koji se prikazuje na dnu stranice.
 * Otvara se u novom tabu, sa naglašenim glow + pulse animacijom da privuče pažnju.
 */
export default function ToniniVisionCTA({ variant = "full" }) {
  if (variant === "compact") {
    return (
      <a
        href={TONINI_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="tonini-vision-cta-compact"
        className="tonini-cta-compact group inline-flex items-center gap-2 px-4 py-2 rounded-sm border border-[#ff7a18]/40 text-[#ff7a18] hover:bg-[#ff7a18]/10 transition-all text-xs uppercase tracking-[0.25em]"
      >
        <Sparkles className="w-3 h-3" />
        <span>Tonini vizija</span>
        <ArrowUpRight className="w-3 h-3 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </a>
    );
  }

  return (
    <div className="w-full flex justify-center pt-2 pb-10" data-testid="tonini-vision-section">
      <a
        href={TONINI_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="tonini-vision-cta"
        className="tonini-cta-link group relative inline-flex items-center gap-3 md:gap-4 px-6 md:px-10 py-4 md:py-5 rounded-sm overflow-hidden"
      >
        {/* Animated border glow */}
        <span className="tonini-cta-border" aria-hidden="true" />

        {/* Inner content */}
        <span className="relative z-10 flex items-center gap-3 md:gap-4">
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-sm bg-[#ff7a18] text-black flex items-center justify-center shrink-0 group-hover:rotate-12 transition-transform">
            <Zap className="w-4 h-4 md:w-5 md:h-5" strokeWidth={2.5} />
          </span>
          <span className="text-left">
            <span className="block text-[9px] md:text-[10px] uppercase tracking-[0.4em] text-[#ff7a18] mb-0.5">
              Ekskluzivno
            </span>
            <span className="block font-display text-sm md:text-base font-bold tracking-wide text-white">
              Saznajte više o <span className="text-[#ff7a18]">Tonini viziji</span> i našem ekosistemu
            </span>
          </span>
          <ArrowUpRight className="w-4 h-4 md:w-5 md:h-5 text-[#22ff77] transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
        </span>
      </a>

      <style>{`
        .tonini-cta-link {
          background:
            linear-gradient(135deg, rgba(255,122,24,0.10), rgba(34,255,119,0.08)),
            #0a0a0a;
          box-shadow:
            0 0 0 1px rgba(255,122,24,0.35),
            0 0 30px rgba(255,122,24,0.15),
            inset 0 0 20px rgba(0,0,0,0.6);
          animation: tonini-pulse 3.4s ease-in-out infinite;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }
        .tonini-cta-link:hover {
          transform: translateY(-2px);
          box-shadow:
            0 0 0 1px rgba(255,122,24,0.85),
            0 0 50px rgba(255,122,24,0.4),
            0 0 80px rgba(34,255,119,0.2);
          animation-play-state: paused;
        }
        .tonini-cta-border {
          position: absolute;
          inset: -1px;
          padding: 1px;
          border-radius: 2px;
          background: conic-gradient(from var(--angle, 0deg),
            rgba(255,122,24,0.0) 0%,
            rgba(255,122,24,0.8) 25%,
            rgba(34,255,119,0.0) 50%,
            rgba(34,255,119,0.6) 75%,
            rgba(255,122,24,0.0) 100%);
          -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
          mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          animation: tonini-spin 6s linear infinite;
        }
        @property --angle {
          syntax: '<angle>';
          initial-value: 0deg;
          inherits: false;
        }
        @keyframes tonini-spin {
          to { --angle: 360deg; }
        }
        @keyframes tonini-pulse {
          0%, 100% { box-shadow:
            0 0 0 1px rgba(255,122,24,0.35),
            0 0 30px rgba(255,122,24,0.15),
            inset 0 0 20px rgba(0,0,0,0.6); }
          50% { box-shadow:
            0 0 0 1px rgba(255,122,24,0.6),
            0 0 50px rgba(255,122,24,0.3),
            inset 0 0 20px rgba(0,0,0,0.6); }
        }
        /* Fallback za brauzere bez @property (samo statički border, bez rotacije) */
        @supports not (background: conic-gradient(from 0deg, red, red)) {
          .tonini-cta-border { display: none; }
        }
        .tonini-cta-compact {
          animation: tonini-pulse-soft 3s ease-in-out infinite;
        }
        @keyframes tonini-pulse-soft {
          0%, 100% { box-shadow: 0 0 0 0 rgba(255,122,24,0); }
          50% { box-shadow: 0 0 0 4px rgba(255,122,24,0.12); }
        }
      `}</style>
    </div>
  );
}
